/* línkè · 头像（2026-07-29 铃点单：像 QQ 那样自己传图当头像）
   ────────────────────────────────────────────────
   两个位子：'user'＝她、'sael'＝他。没传图就回落到原来的 ☾ / ✦ 字符，
   所以这套是「可选的皮」，不改任何既有语义。

   ── 为什么存本机、不进云同步 ──
   头像是 data URL（一张 160px 方图约 8–15KB）。和壁纸同待遇：
   不进 sync.js 的 SYNCED_KEYS，换设备要重新传一次——换来的是不占同步流量、
   也不会因为一张图把同步搞慢。

   ── 为什么不进 themeSkin ──
   壁纸/字色是「这个主题下的外观」，会跟着主题换；头像是「这个人长什么样」，
   四个主题下都该是同一张脸。所以它的 key 不能加进 SKIN_KEYS。 */

export const AVATAR_EVENT = 'lingke:avatar';

const KEYS = {
  user: 'lingke.avatar.user.v1',
  sael: 'lingke.avatar.sael.v1',
};

/* 兜底字符（没传图时用，= 一直以来的样子） */
export const AVATAR_FALLBACK = { user: '☾', sael: '✦' };

/* 存多大：聊天里显示 34px、侧边栏预览 62px，3 倍屏要 186px 才不糊 → 存 192。
   （初版存 160 是按 22px 的显示尺寸算的；2026-07-29 头像改大后一起抬上来。）
   一张约 14KB。 */
export const AVATAR_MAX_EDGE = 192;
export const AVATAR_QUALITY = 0.86;

function keyOf(who) {
  return KEYS[who] || null;
}

/** 读某个人的头像 data URL；没有就 null。 */
export function getAvatar(who) {
  const k = keyOf(who);
  if (!k) return null;
  try {
    return localStorage.getItem(k) || null;
  } catch {
    return null;
  }
}

/** 两个一起读（组件初始化用）。 */
export function getAvatars() {
  return { user: getAvatar('user'), sael: getAvatar('sael') };
}

/** 存一张（dataUrl 为空＝恢复默认字符）。返回错误文案或 null。 */
export function setAvatar(who, dataUrl) {
  const k = keyOf(who);
  if (!k) return '不认识的头像位子';
  try {
    if (dataUrl) localStorage.setItem(k, dataUrl);
    else localStorage.removeItem(k);
  } catch {
    // localStorage 配额满了（壁纸是大头）——说人话，别抛给她一个 QuotaExceededError
    return '存不下了：换张小一点的图，或先把壁纸换成不带图的';
  }
  notifyAvatarChanged();
  return null;
}

export function clearAvatar(who) {
  return setAvatar(who, null);
}

/* 广播「头像换了」——聊天页和抽屉里的 useState 据此重读，不用刷新。 */
export function notifyAvatarChanged() {
  try {
    window.dispatchEvent(new Event(AVATAR_EVENT));
  } catch {}
}

/** React 侧统一订阅入口：返回 { user, sael }，换头像时自动更新。 */
export function subscribeAvatars(fn) {
  const h = () => fn(getAvatars());
  window.addEventListener(AVATAR_EVENT, h);
  return () => window.removeEventListener(AVATAR_EVENT, h);
}
